// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Format dropdown */
.editor-container.adg3-editor #toolbar #format-dropdown .format-p a,
#content.edit.adg3-editor #toolbar #format-dropdown .format-p a,
.editor-container.adg3-editor #toolbar #format-dropdown .format-pre a,
#content.edit.adg3-editor #toolbar #format-dropdown .format-pre a,
.editor-container.adg3-editor #toolbar #format-dropdown .format-blockquote a,
#content.edit.adg3-editor #toolbar #format-dropdown .format-blockquote a {
	color: var(--ds-text, #000);
}

.editor-container.adg3-editor #format-dropdown .dropdown-item,
#content.edit.adg3-editor #format-dropdown .dropdown-item {
	font-weight: normal;
	padding-left: 10px;
	padding-top: 8px;
	height: 18px;
	line-height: 18px;
	font-size: 10pt;
	font-family: Helvetica, Arial, sans-serif;
	/* TODO: Merge the typography styles with the wiki content it represents in wiki-content.css */
}

.editor-container.adg3-editor #toolbar #format-dropdown .format-h1 a,
#content.edit.adg3-editor #toolbar #format-dropdown .format-h1 a {
	font-size: 1.714em;
	font-weight: normal;
	line-height: 1.166;
}

.editor-container.adg3-editor #toolbar #format-dropdown .format-h2 a,
#content.edit.adg3-editor #toolbar #format-dropdown .format-h2 a {
	font-size: 1.43em;
	font-weight: normal;
	line-height: 1.2;
}

.editor-container.adg3-editor #toolbar #format-dropdown .format-h3 a,
#content.edit.adg3-editor #toolbar #format-dropdown .format-h3 a {
	font-size: 1.142em;
	line-height: 1.5;
}

.editor-container.adg3-editor #toolbar #format-dropdown .format-h4 a,
#content.edit.adg3-editor #toolbar #format-dropdown .format-h4 a {
	font-size: 1em;
	line-height: 1.428;
	font-weight: bold;
}

.editor-container.adg3-editor #toolbar #format-dropdown .format-h5 a,
#content.edit.adg3-editor #toolbar #format-dropdown .format-h5 a {
	font-size: 0.857em;
	line-height: 1.333;
	font-weight: bold;
}

.editor-container.adg3-editor #toolbar #format-dropdown .format-h6 a,
#content.edit.adg3-editor #toolbar #format-dropdown .format-h6 a {
	line-height: 1.454;
	font-size: 0.785em;
	color: var(--ds-text-subtlest, #6b778c);
	text-transform: uppercase;
	font-weight: bold;
}

.editor-container.adg3-editor #toolbar #format-dropdown .format-blockquote a,
#content.edit.adg3-editor #toolbar #format-dropdown .format-blockquote a {
	border-left: 1px solid var(--ds-border-bold, #707070);
	padding-left: 10px;
}

.editor-container.adg3-editor #toolbar #format-dropdown .format-pre,
#content.edit.adg3-editor #toolbar #format-dropdown .format-pre {
	font-family: 'Courier New', Courier, monospace;
	/* Auto complete shortcuts*/
}

.editor-container.adg3-editor #autocomplete-dropdown .aui-dropdown,
#content.edit.adg3-editor #autocomplete-dropdown .aui-dropdown {
	padding: 0;
	margin: 0;
	/* border style copied from .aui-dropdown2.aui-style-default */
	/* see: https://ecosystem.atlassian.net/browse/AUI-949 */
	background-color: var(--ds-surface, white);
	border: 1px solid var(--ds-border-bold, #ccc);
	border-radius: 3px;
	-moz-box-shadow: var(--ds-shadow-raised, 0 3px 6px rgba(0, 0, 0, 0.2));
	-webkit-box-shadow: var(--ds-shadow-raised, 0 3px 6px rgba(0, 0, 0, 0.2));
	box-shadow: var(--ds-shadow-raised, 0 3px 6px rgba(0, 0, 0, 0.2));
}

.editor-container.adg3-editor #autocomplete-dropdown .autocomplete-dropdown-arrow,
#content.edit.adg3-editor #autocomplete-dropdown .autocomplete-dropdown-arrow {
	position: absolute;
	top: -7px;
	width: 1px;
	z-index: 2004;
}

.editor-container.adg3-editor #autocomplete-dropdown .autocomplete-dropdown-arrow::after,
#content.edit.adg3-editor #autocomplete-dropdown .autocomplete-dropdown-arrow::after,
.editor-container.adg3-editor #autocomplete-dropdown .autocomplete-dropdown-arrow::before,
#content.edit.adg3-editor #autocomplete-dropdown .autocomplete-dropdown-arrow::before {
	border-color: var(--ds-border-bold, #ccc) transparent;
	border-style: solid;
	border-width: 0 8px 8px;
	content: '';
	left: 2px;
	position: absolute;
	top: 0;
}

.editor-container.adg3-editor #autocomplete-dropdown .autocomplete-dropdown-arrow:after,
#content.edit.adg3-editor #autocomplete-dropdown .autocomplete-dropdown-arrow:after {
	border-bottom-color: var(--ds-border-inverse, #f5f5f5);
	top: 1px;
}

.editor-container.adg3-editor
	#autocomplete-dropdown
	.autocomplete-dropdown-arrow.autocomplete-dropdown-bottom-arrow:after,
#content.edit.adg3-editor
	#autocomplete-dropdown
	.autocomplete-dropdown-arrow.autocomplete-dropdown-bottom-arrow:after,
.editor-container.adg3-editor
	#autocomplete-dropdown
	.autocomplete-dropdown-arrow.autocomplete-dropdown-bottom-arrow:before,
#content.edit.adg3-editor
	#autocomplete-dropdown
	.autocomplete-dropdown-arrow.autocomplete-dropdown-bottom-arrow:before {
	border-width: 8px 8px 0;
}

.editor-container.adg3-editor
	#autocomplete-dropdown
	.autocomplete-dropdown-arrow.autocomplete-dropdown-bottom-arrow:after,
#content.edit.adg3-editor
	#autocomplete-dropdown
	.autocomplete-dropdown-arrow.autocomplete-dropdown-bottom-arrow:after {
	border-top-color: var(--ds-border-inverse, #fff);
	top: -1px;
	/* The 'header' for the auto-complete dropdown */
}

.editor-container.adg3-editor #autocomplete-dropdown .aui-dropdown ol.top-menu-item,
#content.edit.adg3-editor #autocomplete-dropdown .aui-dropdown ol.top-menu-item {
	border-bottom-color: var(--ds-border-bold, #ccc);
	font-size: 14px;
	padding: 0;
}

.editor-container.adg3-editor #autocomplete-dropdown .aui-dropdown ol.top-menu-item li,
#content.edit.adg3-editor #autocomplete-dropdown .aui-dropdown ol.top-menu-item li,
.editor-container.adg3-editor #autocomplete-dropdown .aui-dropdown ol.top-menu-item li:hover,
#content.edit.adg3-editor #autocomplete-dropdown .aui-dropdown ol.top-menu-item li:hover {
	background: var(--ds-background-input-hovered, #f5f5f5);
	height: 24px;
	line-height: 24px;
	margin: 0;
	padding: 2px 5px;
}

.editor-container.adg3-editor #autocomplete-dropdown .aui-dropdown ol.top-menu-item li:hover span,
#content.edit.adg3-editor #autocomplete-dropdown .aui-dropdown ol.top-menu-item li:hover span {
	background: none;
	color: var(--ds-text, #333);
}

.editor-container.adg3-editor
	#autocomplete-dropdown
	.aui-dropdown
	ol.top-menu-item
	li
	a.menu-header,
#content.edit.adg3-editor #autocomplete-dropdown .aui-dropdown ol.top-menu-item li a.menu-header {
	cursor: default;
}

.editor-container.adg3-editor
	#autocomplete-dropdown
	.aui-dropdown
	ol.top-menu-item
	li
	a.menu-header:hover,
#content.edit.adg3-editor
	#autocomplete-dropdown
	.aui-dropdown
	ol.top-menu-item
	li
	a.menu-header:hover,
.editor-container.adg3-editor #autocomplete-dropdown .aui-dropdown ol.top-menu-item li:hover,
#content.edit.adg3-editor #autocomplete-dropdown .aui-dropdown ol.top-menu-item li:hover {
	color: var(--ds-text, #333);
}

.editor-container.adg3-editor
	#autocomplete-dropdown
	.aui-dropdown
	ol.top-menu-item
	li
	a.menu-header
	span,
#content.edit.adg3-editor
	#autocomplete-dropdown
	.aui-dropdown
	ol.top-menu-item
	li
	a.menu-header
	span {
	background: var(--ds-background-input-hovered, #f5f5f5);
	padding-left: 0;
}

.editor-container.adg3-editor #autocomplete-dropdown .aui-dropdown li span.no-result,
#content.edit.adg3-editor #autocomplete-dropdown .aui-dropdown li span.no-result {
	padding: 2px 5px;
}

.editor-container.adg3-editor #autocomplete-dropdown .aui-dropdown li,
#content.edit.adg3-editor #autocomplete-dropdown .aui-dropdown li {
	padding: 4px 0;
}

.editor-container.adg3-editor #autocomplete-dropdown .aui-dropdown.autocomplete-mentions li a span,
#content.edit.adg3-editor #autocomplete-dropdown .aui-dropdown.autocomplete-mentions li a span {
	padding-left: 38px;
}

.editor-container.adg3-editor #autocomplete-dropdown .aui-dropdown li img,
#content.edit.adg3-editor #autocomplete-dropdown .aui-dropdown li img {
	margin: 4px;
	border-radius: 3px;
	width: 24px;
	height: 24px;
}
`, "",{"version":3,"sources":["webpack://./../confluence-editor/src/adg3-styles/tinymce-editor.css"],"names":[],"mappings":"AAAA,oBAAoB;AACpB;;;;;;CAMC,2BAA2B;AAC5B;;AAEA;;CAEC,mBAAmB;CACnB,kBAAkB;CAClB,gBAAgB;CAChB,YAAY;CACZ,iBAAiB;CACjB,eAAe;CACf,yCAAyC;CACzC,8FAA8F;AAC/F;;AAEA;;CAEC,kBAAkB;CAClB,mBAAmB;CACnB,kBAAkB;AACnB;;AAEA;;CAEC,iBAAiB;CACjB,mBAAmB;CACnB,gBAAgB;AACjB;;AAEA;;CAEC,kBAAkB;CAClB,gBAAgB;AACjB;;AAEA;;CAEC,cAAc;CACd,kBAAkB;CAClB,iBAAiB;AAClB;;AAEA;;CAEC,kBAAkB;CAClB,kBAAkB;CAClB,iBAAiB;AAClB;;AAEA;;CAEC,kBAAkB;CAClB,kBAAkB;CAClB,uCAAuC;CACvC,yBAAyB;CACzB,iBAAiB;AAClB;;AAEA;;CAEC,qDAAqD;CACrD,kBAAkB;AACnB;;AAEA;;CAEC,8CAA8C;CAC9C,2BAA2B;AAC5B;;AAEA;;CAEC,UAAU;CACV,SAAS;CACT,8DAA8D;CAC9D,wDAAwD;CACxD,0CAA0C;CAC1C,6CAA6C;CAC7C,kBAAkB;CAClB,sEAAsE;CACtE,yEAAyE;CACzE,iEAAiE;AAClE;;AAEA;;CAEC,kBAAkB;CAClB,SAAS;CACT,UAAU;CACV,aAAa;AACd;;AAEA;;;;CAIC,qDAAqD;CACrD,mBAAmB;CACnB,uBAAuB;CACvB,WAAW;CACX,SAAS;CACT,kBAAkB;CAClB,MAAM;AACP;;AAEA;;CAEC,sDAAsD;CACtD,QAAQ;AACT;;AAEA;;;;;;;;;;;;CAYC,uBAAuB;AACxB;;AAEA;;;;;;CAMC,gDAAgD;CAChD,SAAS;CACT,gDAAgD;AACjD;;AAEA;;CAEC,gDAAgD;CAChD,eAAe;CACf,UAAU;AACX;;AAEA;;;;CAIC,uDAAuD;CACvD,YAAY;CACZ,iBAAiB;CACjB,SAAS;CACT,gBAAgB;AACjB;;AAEA;;CAEC,gBAAgB;CAChB,2BAA2B;AAC5B;;AAEA;;;;;;;CAOC,eAAe;AAChB;;AAEA;;;;;;;;;;;;;;CAcC,2BAA2B;AAC5B;;AAEA;;;;;;;;;;;;;;CAcC,uDAAuD;CACvD,eAAe;AAChB;;AAEA;;CAEC,gBAAgB;AACjB;;AAEA;;CAEC,cAAc;AACf;;AAEA;;CAEC,kBAAkB;AACnB;;AAEA;;CAEC,WAAW;CACX,kBAAkB;CAClB,WAAW;CACX,YAAY;AACb","sourcesContent":["/* Format dropdown */\n.editor-container.adg3-editor #toolbar #format-dropdown .format-p a,\n#content.edit.adg3-editor #toolbar #format-dropdown .format-p a,\n.editor-container.adg3-editor #toolbar #format-dropdown .format-pre a,\n#content.edit.adg3-editor #toolbar #format-dropdown .format-pre a,\n.editor-container.adg3-editor #toolbar #format-dropdown .format-blockquote a,\n#content.edit.adg3-editor #toolbar #format-dropdown .format-blockquote a {\n\tcolor: var(--ds-text, #000);\n}\n\n.editor-container.adg3-editor #format-dropdown .dropdown-item,\n#content.edit.adg3-editor #format-dropdown .dropdown-item {\n\tfont-weight: normal;\n\tpadding-left: 10px;\n\tpadding-top: 8px;\n\theight: 18px;\n\tline-height: 18px;\n\tfont-size: 10pt;\n\tfont-family: Helvetica, Arial, sans-serif;\n\t/* TODO: Merge the typography styles with the wiki content it represents in wiki-content.css */\n}\n\n.editor-container.adg3-editor #toolbar #format-dropdown .format-h1 a,\n#content.edit.adg3-editor #toolbar #format-dropdown .format-h1 a {\n\tfont-size: 1.714em;\n\tfont-weight: normal;\n\tline-height: 1.166;\n}\n\n.editor-container.adg3-editor #toolbar #format-dropdown .format-h2 a,\n#content.edit.adg3-editor #toolbar #format-dropdown .format-h2 a {\n\tfont-size: 1.43em;\n\tfont-weight: normal;\n\tline-height: 1.2;\n}\n\n.editor-container.adg3-editor #toolbar #format-dropdown .format-h3 a,\n#content.edit.adg3-editor #toolbar #format-dropdown .format-h3 a {\n\tfont-size: 1.142em;\n\tline-height: 1.5;\n}\n\n.editor-container.adg3-editor #toolbar #format-dropdown .format-h4 a,\n#content.edit.adg3-editor #toolbar #format-dropdown .format-h4 a {\n\tfont-size: 1em;\n\tline-height: 1.428;\n\tfont-weight: bold;\n}\n\n.editor-container.adg3-editor #toolbar #format-dropdown .format-h5 a,\n#content.edit.adg3-editor #toolbar #format-dropdown .format-h5 a {\n\tfont-size: 0.857em;\n\tline-height: 1.333;\n\tfont-weight: bold;\n}\n\n.editor-container.adg3-editor #toolbar #format-dropdown .format-h6 a,\n#content.edit.adg3-editor #toolbar #format-dropdown .format-h6 a {\n\tline-height: 1.454;\n\tfont-size: 0.785em;\n\tcolor: var(--ds-text-subtlest, #6b778c);\n\ttext-transform: uppercase;\n\tfont-weight: bold;\n}\n\n.editor-container.adg3-editor #toolbar #format-dropdown .format-blockquote a,\n#content.edit.adg3-editor #toolbar #format-dropdown .format-blockquote a {\n\tborder-left: 1px solid var(--ds-border-bold, #707070);\n\tpadding-left: 10px;\n}\n\n.editor-container.adg3-editor #toolbar #format-dropdown .format-pre,\n#content.edit.adg3-editor #toolbar #format-dropdown .format-pre {\n\tfont-family: 'Courier New', Courier, monospace;\n\t/* Auto complete shortcuts*/\n}\n\n.editor-container.adg3-editor #autocomplete-dropdown .aui-dropdown,\n#content.edit.adg3-editor #autocomplete-dropdown .aui-dropdown {\n\tpadding: 0;\n\tmargin: 0;\n\t/* border style copied from .aui-dropdown2.aui-style-default */\n\t/* see: https://ecosystem.atlassian.net/browse/AUI-949 */\n\tbackground-color: var(--ds-surface, white);\n\tborder: 1px solid var(--ds-border-bold, #ccc);\n\tborder-radius: 3px;\n\t-moz-box-shadow: var(--ds-shadow-raised, 0 3px 6px rgba(0, 0, 0, 0.2));\n\t-webkit-box-shadow: var(--ds-shadow-raised, 0 3px 6px rgba(0, 0, 0, 0.2));\n\tbox-shadow: var(--ds-shadow-raised, 0 3px 6px rgba(0, 0, 0, 0.2));\n}\n\n.editor-container.adg3-editor #autocomplete-dropdown .autocomplete-dropdown-arrow,\n#content.edit.adg3-editor #autocomplete-dropdown .autocomplete-dropdown-arrow {\n\tposition: absolute;\n\ttop: -7px;\n\twidth: 1px;\n\tz-index: 2004;\n}\n\n.editor-container.adg3-editor #autocomplete-dropdown .autocomplete-dropdown-arrow::after,\n#content.edit.adg3-editor #autocomplete-dropdown .autocomplete-dropdown-arrow::after,\n.editor-container.adg3-editor #autocomplete-dropdown .autocomplete-dropdown-arrow::before,\n#content.edit.adg3-editor #autocomplete-dropdown .autocomplete-dropdown-arrow::before {\n\tborder-color: var(--ds-border-bold, #ccc) transparent;\n\tborder-style: solid;\n\tborder-width: 0 8px 8px;\n\tcontent: '';\n\tleft: 2px;\n\tposition: absolute;\n\ttop: 0;\n}\n\n.editor-container.adg3-editor #autocomplete-dropdown .autocomplete-dropdown-arrow:after,\n#content.edit.adg3-editor #autocomplete-dropdown .autocomplete-dropdown-arrow:after {\n\tborder-bottom-color: var(--ds-border-inverse, #f5f5f5);\n\ttop: 1px;\n}\n\n.editor-container.adg3-editor\n\t#autocomplete-dropdown\n\t.autocomplete-dropdown-arrow.autocomplete-dropdown-bottom-arrow:after,\n#content.edit.adg3-editor\n\t#autocomplete-dropdown\n\t.autocomplete-dropdown-arrow.autocomplete-dropdown-bottom-arrow:after,\n.editor-container.adg3-editor\n\t#autocomplete-dropdown\n\t.autocomplete-dropdown-arrow.autocomplete-dropdown-bottom-arrow:before,\n#content.edit.adg3-editor\n\t#autocomplete-dropdown\n\t.autocomplete-dropdown-arrow.autocomplete-dropdown-bottom-arrow:before {\n\tborder-width: 8px 8px 0;\n}\n\n.editor-container.adg3-editor\n\t#autocomplete-dropdown\n\t.autocomplete-dropdown-arrow.autocomplete-dropdown-bottom-arrow:after,\n#content.edit.adg3-editor\n\t#autocomplete-dropdown\n\t.autocomplete-dropdown-arrow.autocomplete-dropdown-bottom-arrow:after {\n\tborder-top-color: var(--ds-border-inverse, #fff);\n\ttop: -1px;\n\t/* The 'header' for the auto-complete dropdown */\n}\n\n.editor-container.adg3-editor #autocomplete-dropdown .aui-dropdown ol.top-menu-item,\n#content.edit.adg3-editor #autocomplete-dropdown .aui-dropdown ol.top-menu-item {\n\tborder-bottom-color: var(--ds-border-bold, #ccc);\n\tfont-size: 14px;\n\tpadding: 0;\n}\n\n.editor-container.adg3-editor #autocomplete-dropdown .aui-dropdown ol.top-menu-item li,\n#content.edit.adg3-editor #autocomplete-dropdown .aui-dropdown ol.top-menu-item li,\n.editor-container.adg3-editor #autocomplete-dropdown .aui-dropdown ol.top-menu-item li:hover,\n#content.edit.adg3-editor #autocomplete-dropdown .aui-dropdown ol.top-menu-item li:hover {\n\tbackground: var(--ds-background-input-hovered, #f5f5f5);\n\theight: 24px;\n\tline-height: 24px;\n\tmargin: 0;\n\tpadding: 2px 5px;\n}\n\n.editor-container.adg3-editor #autocomplete-dropdown .aui-dropdown ol.top-menu-item li:hover span,\n#content.edit.adg3-editor #autocomplete-dropdown .aui-dropdown ol.top-menu-item li:hover span {\n\tbackground: none;\n\tcolor: var(--ds-text, #333);\n}\n\n.editor-container.adg3-editor\n\t#autocomplete-dropdown\n\t.aui-dropdown\n\tol.top-menu-item\n\tli\n\ta.menu-header,\n#content.edit.adg3-editor #autocomplete-dropdown .aui-dropdown ol.top-menu-item li a.menu-header {\n\tcursor: default;\n}\n\n.editor-container.adg3-editor\n\t#autocomplete-dropdown\n\t.aui-dropdown\n\tol.top-menu-item\n\tli\n\ta.menu-header:hover,\n#content.edit.adg3-editor\n\t#autocomplete-dropdown\n\t.aui-dropdown\n\tol.top-menu-item\n\tli\n\ta.menu-header:hover,\n.editor-container.adg3-editor #autocomplete-dropdown .aui-dropdown ol.top-menu-item li:hover,\n#content.edit.adg3-editor #autocomplete-dropdown .aui-dropdown ol.top-menu-item li:hover {\n\tcolor: var(--ds-text, #333);\n}\n\n.editor-container.adg3-editor\n\t#autocomplete-dropdown\n\t.aui-dropdown\n\tol.top-menu-item\n\tli\n\ta.menu-header\n\tspan,\n#content.edit.adg3-editor\n\t#autocomplete-dropdown\n\t.aui-dropdown\n\tol.top-menu-item\n\tli\n\ta.menu-header\n\tspan {\n\tbackground: var(--ds-background-input-hovered, #f5f5f5);\n\tpadding-left: 0;\n}\n\n.editor-container.adg3-editor #autocomplete-dropdown .aui-dropdown li span.no-result,\n#content.edit.adg3-editor #autocomplete-dropdown .aui-dropdown li span.no-result {\n\tpadding: 2px 5px;\n}\n\n.editor-container.adg3-editor #autocomplete-dropdown .aui-dropdown li,\n#content.edit.adg3-editor #autocomplete-dropdown .aui-dropdown li {\n\tpadding: 4px 0;\n}\n\n.editor-container.adg3-editor #autocomplete-dropdown .aui-dropdown.autocomplete-mentions li a span,\n#content.edit.adg3-editor #autocomplete-dropdown .aui-dropdown.autocomplete-mentions li a span {\n\tpadding-left: 38px;\n}\n\n.editor-container.adg3-editor #autocomplete-dropdown .aui-dropdown li img,\n#content.edit.adg3-editor #autocomplete-dropdown .aui-dropdown li img {\n\tmargin: 4px;\n\tborder-radius: 3px;\n\twidth: 24px;\n\theight: 24px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
